document.addEventListener("DOMContentLoaded", () => {
  const STORAGE_KEY = "custom_wishlist";
  const container = document.querySelector(".wishlist-products-container");
  const emptyEl = document.querySelector(".wishlist-empty");
  const clearBtn = document.querySelector(".wishlist-clear-btn");
  const wishlistCountEls = document.querySelectorAll(".wishlist-icon-count");

  // ===== Helpers =====
  const getWishlist = () => JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
  const setWishlist = items => localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  const isInWishlist = handle => getWishlist().includes(handle);

  const updateCount = () => {
    const count = getWishlist().length;
    wishlistCountEls.forEach(el => el.textContent = count);
    if (clearBtn) clearBtn.style.display = count ? "inline-block" : "none";
    if (container) {
      container.style.display = count ? "grid" : "none";
      if (emptyEl) emptyEl.style.display = count ? "none" : "block";
    }
  };

  const updateAllButtons = () => {
    document.querySelectorAll(".wishlist-button, .wishlist-btn, .wishlist-action-btn").forEach(btn => {
      const handle = btn.dataset.handle || btn.dataset.productHandle;
      if (!handle) return;
      const active = isInWishlist(handle);
      btn.classList.toggle("active", active);
      btn.setAttribute("aria-pressed", active);
    });
  };

  // ===== Fetch product JSON =====
  const fetchProduct = async handle => {
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) return null;
      const product = await res.json();
      return {
        title: product.title,
        handle: product.handle,
        onlineStoreUrl: product.url || `/products/${product.handle}`,
        images: product.images || [],
        price: product.price / 100,
        compareAtPrice: product.compare_at_price ? product.compare_at_price / 100 : 0,
        availableForSale: product.available
      };
    } catch (e) {
      console.error("Failed to fetch product:", handle, e);
      return null;
    }
  };

  // ===== Create wishlist card =====
  const createWishlistCard = product => {
    if (!product) return null;

    const div = document.createElement("div");
    div.className = "wishlist-product-card";
    div.dataset.handle = product.handle;

    const onSale = product.compareAtPrice > product.price;
    const priceFormatted = new Intl.NumberFormat('en', { style: 'currency', currency: 'USD' }).format(product.price);
    const compareFormatted = onSale ? new Intl.NumberFormat('en', { style: 'currency', currency: 'USD' }).format(product.compareAtPrice) : '';

    div.innerHTML = `
      <div class="custom-card">
        <div class="custom-card-top">
          <button class="wishlist-btn ${isInWishlist(product.handle) ? 'active' : ''}" 
                  data-handle="${product.handle}" 
                  aria-pressed="${isInWishlist(product.handle) ? 'true' : 'false'}">
            <svg fill="currentColor" height="20px" width="20px" viewBox="0 0 512 512">
              <path d="M365.109,44.405c-42.169,0-81.27,17.539-109.109,48.529c-27.839-30.99-66.941-48.529-109.109-48.529
              C65.895,44.405,0,110.3,0,191.296c0,43.071,16.216,84.357,48.196,122.708c26.609,31.909,58.993,56.065,82.64,73.703l3.208,2.394
              c49.059,36.648,53.157,39.031,92.364,61.837c6.895,4.01,14.89,8.661,24.432,14.256c1.593,0.934,3.376,1.401,5.16,1.401
              s3.567-0.467,5.159-1.4c9.542-5.595,17.538-10.246,24.432-14.256c39.207-22.805,43.305-25.189,92.364-61.837l3.208-2.394
              c23.646-17.638,56.031-41.792,82.64-73.703C495.784,275.652,512,234.367,512,191.296
              C512,110.3,446.105,44.405,365.109,44.405z"></path>
            </svg>
          </button>
        </div>
        <a href="${product.onlineStoreUrl}" class="custom-card-link">
          <div class="custom-card-image-wrapper">
            ${product.images[0] ? `<img src="${product.images[0]}" alt="${product.title}" class="custom-card-image">` : ""}
            ${product.images[1] ? `<img src="${product.images[1]}" alt="${product.title}" class="custom-card-image secondary-image">` : ""}
          </div>
          <div class="custom-card-content">
            <h3>${product.title}</h3>
            <p>${onSale ? `<span class="price-sale">${priceFormatted}</span> <span class="price-compare">${compareFormatted}</span>` : priceFormatted}</p>
            ${!product.availableForSale ? `<div class="soldout-badge">Sold Out</div>` : ""}
          </div>
        </a>
      </div>
    `;
    return div;
  };

  // ===== Render wishlist products =====
  const renderWishlistProducts = async () => {
    if (!container) return;
    container.innerHTML = "";
    const handles = getWishlist();
    for (const handle of handles) {
      const product = await fetchProduct(handle);
      if (!product) continue;
      const card = createWishlistCard(product);
      if (card) container.appendChild(card);
    }
  };

  // ===== Toggle wishlist =====
  const toggleWishlist = async handle => {
    let items = getWishlist();
    const removing = items.includes(handle);

    if (removing) items = items.filter(h => h !== handle);
    else items.push(handle);

    setWishlist(items);
    updateCount();
    updateAllButtons();

    // Remove from wishlist page if present
    if (container && removing) {
      const card = container.querySelector(`.wishlist-product-card[data-handle="${handle}"]`);
      if (card) card.remove();
    }

    // Add to wishlist page if adding
    if (container && !removing) {
      const product = await fetchProduct(handle);
      if (product) container.appendChild(createWishlistCard(product));
    }
  };

  // ===== Event listener =====
 document.body.addEventListener("click", async (e) => {
  const btn = e.target.closest(".wishlist-button, .wishlist-btn, .wishlist-action-btn");
  if (btn) {
    // Stop default and parent <a> navigation
    e.preventDefault();
    e.stopPropagation();

    const handle = btn.dataset.handle || btn.dataset.productHandle;
    if (!handle) return;

    await toggleWishlist(handle);
  }

  const clearBtnEl = e.target.closest(".wishlist-clear-btn");
  if (clearBtnEl) {
    e.preventDefault();
    setWishlist([]);
    if (container) container.innerHTML = "";
    updateCount();
    updateAllButtons();
  }
});

  // ===== Init =====
  updateCount();
  updateAllButtons();
  renderWishlistProducts();
});